import styled from "styled-components"

export const Icon = styled.img`
  height: 8rem;
`

export default Icon
